(() => {
 const dock=document.querySelector('[data-smd-mobile-dock]');
 const menu=document.querySelector('[data-smd-mobile-menu-dialog]');
 const button=dock?.querySelector('[data-smd-mobile-menu]');
 if(!dock||!menu||!button)return;
 document.body.append(dock,menu);
 const mobile=matchMedia('(max-width:749px)'),reduced=matchMedia('(prefers-reduced-motion:reduce)');
 const panel=menu.querySelector('.smd-mobile-menu__panel');
 panel.style.animation='none';
 menu.style.animation='none';
 menu.style.transform='none';
 menu.style.translate='none';
 let previousOverflow,closing=false,drawerAnimation;
 const animations=new Map(), expansions=new Map();
 const viewport=()=>{const v=window.visualViewport;menu.style.height=`${v?.height||innerHeight}px`;menu.style.top=`${v?.offsetTop||0}px`;};
 window.visualViewport?.addEventListener('resize',viewport);
 window.visualViewport?.addEventListener('scroll',viewport);
 window.addEventListener('resize',viewport);
 // Same spring solver and opening parameters as the desktop JellyRadio menu.
 const sample=(to,initial,stiffness,mass,bounce)=>{
  let value=initial,velocity=0;const damping=2*Math.sqrt(stiffness*mass)*(1-bounce),frames=[];
  for(let step=0;step<=60;step++){frames.push(value);for(let sub=0;sub<4;sub++){velocity+=(-stiffness*(value-to)-damping*velocity)/mass/240;value+=velocity/240;}}
  frames[frames.length-1]=to;return frames;
 };
 const scale=sample(1,.96,580,.85,.25),opacity=sample(1,.5,580,.9,.2);
 const frames=scale.map((value,i)=>({transform:`scale(${value},${2-value})`,opacity:Math.min(1,Math.max(0,opacity[i]))}));
 let swipeStart;
 const jelly=target=>{
  if(reduced.matches||!target)return;
  let skin=target.querySelector(':scope > .smd-mobile-jelly-skin');
  if(!skin){skin=document.createElement('span');skin.className='smd-mobile-jelly-skin';skin.setAttribute('aria-hidden','true');target.prepend(skin);}
  target=skin;
  animations.get(target)?.cancel();
  const animation=target.animate(frames,{duration:520,easing:'linear',fill:'backwards'});
  animations.set(target,animation);animation.onfinish=()=>{animation.cancel();animations.delete(target);};
 };
 const reset=()=>{
  if(menu.open)return;
  drawerAnimation?.cancel();drawerAnimation=undefined;
  closing=false;button.setAttribute('aria-expanded','false');button.setAttribute('aria-label','Abrir menu');button.classList.remove('is-active');
  animations.forEach(animation=>animation.cancel());animations.clear();
  expansions.forEach(state=>{state.animation?.cancel();state.content.style.height='';state.content.style.overflow='';});expansions.clear();
  menu.querySelectorAll('details[open]').forEach(item=>{item.open=false;});
  if(previousOverflow!==undefined){document.body.style.overflow=previousOverflow;previousOverflow=undefined;}
 };
 const close=(immediate=false)=>{
  if(!menu.open||(closing&&!immediate))return;
  closing=true;
  const startTransform=getComputedStyle(panel).transform;
  drawerAnimation?.cancel();
  if(immediate||reduced.matches){menu.close();reset();return;}
  const animation=panel.animate([{transform:startTransform,opacity:1},{transform:'translateX(105%)',opacity:0}],{duration:220,easing:'cubic-bezier(.4,0,1,1)',fill:'forwards'});
  drawerAnimation=animation;
  animation.onfinish=()=>{if(drawerAnimation!==animation)return;menu.close();animation.cancel();drawerAnimation=undefined;reset();};
 };
 button.addEventListener('click',()=>{
  if(menu.open){close();return;}if(!mobile.matches)return;
  window.smdFavorites?.close(false);
  drawerAnimation?.cancel();
  panel.style.transform='translateX(0)';
  previousOverflow=document.body.style.overflow;viewport();menu.showModal();document.body.style.overflow='hidden';
  menu.scrollLeft=0;
  if(reduced.matches)panel.style.transform='translateX(0)';
  else {
   const animation=panel.animate([{transform:'translateX(105%)'},{transform:'translateX(0)'}],{duration:320,easing:'cubic-bezier(.22,.8,.25,1)',fill:'both'});
   drawerAnimation=animation;
   animation.onfinish=()=>{if(drawerAnimation!==animation)return;panel.style.transform='translateX(0)';animation.cancel();drawerAnimation=undefined;};
  }
  button.setAttribute('aria-expanded','true');button.setAttribute('aria-label','Fechar menu');button.classList.add('is-active');
 });
 menu.addEventListener('close',reset);
 menu.addEventListener('cancel',event=>{event.preventDefault();close();});
 panel.addEventListener('pointerdown',event=>{if(event.pointerType==='touch')swipeStart={x:event.clientX,y:event.clientY};},{passive:true});
 panel.addEventListener('pointerup',event=>{
  if(!swipeStart)return;
  const dx=event.clientX-swipeStart.x,dy=event.clientY-swipeStart.y;swipeStart=undefined;
  if(dx>80&&dx>Math.abs(dy)*1.25)close();
 },{passive:true});
 panel.addEventListener('pointercancel',()=>{swipeStart=undefined;},{passive:true});
 menu.addEventListener('click',event=>{
  if(closing)return;
  if(event.target===menu||event.target.closest('[data-smd-mobile-menu-close]')){close();return;}
  if(event.target.closest('a')){close(true);return;}
  const summary=event.target.closest('summary');if(!summary)return;
  event.preventDefault();
  const details=summary.parentElement,content=details.querySelector(':scope > .smd-mobile-menu__children');
  const previous=expansions.get(details),opening=!(previous?.opening??details.open);
  const from=details.open?content.getBoundingClientRect().height:0;
  previous?.animation?.cancel();
  details.open=true;content.style.overflow='hidden';content.style.height=from+'px';
  const to=opening?content.scrollHeight:0;
  jelly(summary);
  if(reduced.matches){details.open=opening;content.style.height='';content.style.overflow='';expansions.delete(details);return;}
  const animation=content.animate([{height:from+'px',opacity:opening?0:1},{height:to+'px',opacity:opening?1:0}],{duration:opening?360:260,easing:'cubic-bezier(.2,.8,.2,1)',fill:'forwards'});
  const state={opening,animation,content};expansions.set(details,state);
  animation.onfinish=()=>{if(expansions.get(details)!==state)return;details.open=opening;content.style.height='';content.style.overflow='';animation.cancel();expansions.delete(details);};
 });
 mobile.addEventListener('change',()=>{if(!mobile.matches)close(true);});
 dock.querySelector('[data-smd-mobile-cart]')?.addEventListener('click',event=>{
  close(true);window.smdFavorites?.close(false);const trigger=document.querySelector('[data-testid="cart-drawer-trigger"]');
  if(trigger)trigger.click();else location.assign(event.currentTarget.dataset.cartUrl||'/cart');
 });
 window.smdMobileMenu={close};
})();
